"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactPopper = require("react-popper");

var _togaPortal = _interopRequireDefault(require("@thinkific/toga-portal"));

var _constants = require("./constants");

var _RootRef = _interopRequireDefault(require("./components/RootRef"));

var _Tooltip = _interopRequireDefault(require("./Tooltip.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Tooltip["default"]);

var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  // Corresponds to 10 frames at 60 Hz.
  function Tooltip(props, context) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "enterTimer", null);

    _defineProperty(_assertThisInitialized(_this), "leaveTimer", null);

    _defineProperty(_assertThisInitialized(_this), "touchTimer", null);

    _defineProperty(_assertThisInitialized(_this), "closeTimer", null);

    _defineProperty(_assertThisInitialized(_this), "isControlled", null);

    _defineProperty(_assertThisInitialized(_this), "popper", null);

    _defineProperty(_assertThisInitialized(_this), "children", null);

    _defineProperty(_assertThisInitialized(_this), "ignoreNonTouchEvents", false);

    _defineProperty(_assertThisInitialized(_this), "handleResize", (0, _lodash["default"])(function () {
      if (_this.popper) {
        _this.popper._popper.scheduleUpdate();
      }
    }, _constants.RESIZE_DEBOUNCE_MS));

    _defineProperty(_assertThisInitialized(_this), "handleEnter", function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;
      var childrenProps = children.props;

      if (event.type === 'focus' && childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function (event) {
      var _this$props2 = _this.props,
          onOpen = _this$props2.onOpen,
          title = _this$props2.title;

      if (!_this.isControlled) {
        // There is no point in displaying an empty tooltip.
        if (title !== '') {
          _this.setState({
            stateOpen: true,
            stateShow: true
          });
        }
      }

      if (onOpen) {
        onOpen(event, true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeave", function (event) {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          leaveDelay = _this$props3.leaveDelay;
      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (event) {
      var onClose = _this.props.onClose;

      if (!_this.isControlled) {
        _this.setState({
          stateOpen: false
        });
      }

      if (onClose) {
        onClose(event, false);
      }

      clearTimeout(_this.closeTimer);
      _this.closeTimer = setTimeout(function () {
        _this.ignoreNonTouchEvents = false;
      }, _constants.IGNORE_NON_TOUCH_EVENTS_MS);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTouchStart", function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props4 = _this.props,
          children = _this$props4.children,
          enterTouchDelay = _this$props4.enterTouchDelay;
      var childrenProps = children.props;

      if (childrenProps.onTouchStart) {
        childrenProps.onTouchStart(event);
      }

      clearTimeout(_this.leaveTimer);
      clearTimeout(_this.closeTimer);
      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTouchEnd", function (event) {
      var _this$props5 = _this.props,
          children = _this$props5.children,
          leaveTouchDelay = _this$props5.leaveTouchDelay;
      var childrenProps = children.props;

      if (childrenProps.onTouchEnd) {
        childrenProps.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    });

    _this.isControlled = props.isOpen !== null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state = {
        // stateOpen refers to whether the 'tooltip' div is rendered
        stateOpen: false,
        // stateShow refers to whether the 'tooltip' div is hidden/shown (opacity)
        stateShow: false
      };
    } else {
      _this.state = {};
    }

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
      clearTimeout(this.touchTimer);
      clearTimeout(this.closeTimer);
      this.handleResize.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          arrowClassName = _this$props6.arrowClassName,
          children = _this$props6.children,
          className = _this$props6.className,
          innerClassName = _this$props6.innerClassName,
          isDark = _this$props6.isDark,
          isDisableFocusListener = _this$props6.isDisableFocusListener,
          isDisableHoverListener = _this$props6.isDisableHoverListener,
          hasTouchListener = _this$props6.hasTouchListener,
          isOpen = _this$props6.isOpen,
          placement = _this$props6.placement,
          title = _this$props6.title,
          _this$state = this.state,
          stateShow = _this$state.stateShow,
          stateOpen = _this$state.stateOpen;
      var open = this.isControlled ? isOpen : stateOpen;
      var childrenProps = {};

      if (hasTouchListener) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!isDisableHoverListener) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!isDisableFocusListener) {
        childrenProps.onFocus = this.handleEnter;
        childrenProps.onBlur = this.handleLeave;
      }

      return /*#__PURE__*/_react["default"].createElement(_reactPopper.Manager, null, /*#__PURE__*/_react["default"].createElement(_reactEventListener["default"], {
        target: "window",
        onResize: this.handleResize
      }), /*#__PURE__*/_react["default"].createElement(_reactPopper.Reference, null, function (_ref) {
        var ref = _ref.ref;
        return /*#__PURE__*/_react["default"].createElement(_RootRef["default"], {
          rootRef: function rootRef(node) {
            return ref(node);
          }
        }, _react["default"].cloneElement(children, childrenProps));
      }), /*#__PURE__*/_react["default"].createElement(_togaPortal["default"], null, /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, {
        eventsEnabled: stateShow,
        modifiers: {
          offset: {
            offset: '0,4'
          },
          preventOverflow: {
            enabled: true
          },
          hide: {
            enabled: false
          }
        },
        placement: placement,
        positionFixed: false
      }, function (_ref2) {
        var ref = _ref2.ref,
            style = _ref2.style,
            popperPlacement = _ref2.placement,
            arrowProps = _ref2.arrowProps;
        return open && /*#__PURE__*/_react["default"].createElement("div", {
          className: cx('tooltip', 'fade', "bs-tooltip-".concat(popperPlacement), {
            show: stateShow,
            'tooltip--dark': isDark === true
          }, className),
          ref: ref,
          style: style,
          "x-placement": popperPlacement
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: cx('arrow', arrowClassName),
          ref: arrowProps.ref,
          style: arrowProps.style
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: cx('tooltip-inner', innerClassName)
        }, title));
      })));
    }
  }]);

  return Tooltip;
}(_react["default"].Component);

Tooltip.propTypes = {
  /**
   * Arrow CSS classes
   */
  arrowClassName: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),

  /**
   * Tooltip reference element.
   */
  children: _propTypes["default"].element.isRequired,

  /** CSS classes */
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes["default"].number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes["default"].number,

  /**
   * Do not respond to long press touch events.
   */
  hasTouchListener: _propTypes["default"].bool,

  /** Inner Tooltip classes */
  innerClassName: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),

  /**
   * Invert colours
   */
  isDark: _propTypes["default"].bool,

  /**
   * Do not respond to focus events.
   */
  isDisableFocusListener: _propTypes["default"].bool,

  /**
   * Do not respond to hover events.
   */
  isDisableHoverListener: _propTypes["default"].bool,

  /**
   * If `true`, the tooltip is shown.
   */
  isOpen: _propTypes["default"].bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes["default"].number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes["default"].number,

  /**
   * Tooltip placement
   * Popper supports a bigger set of placements, we are hiding it now because
   * bootstrap does not handle the style of the arrow for all of these.
   * More info about supported placements https://popper.js.org/popper-documentation.html#Popper.placements
   */
  placement: _propTypes["default"].oneOf(['bottom', 'left', 'right', 'top']),

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes["default"].node.isRequired,

  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes["default"].func,

  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes["default"].func
};
Tooltip.defaultProps = {
  arrowClassName: null,
  className: null,
  enterDelay: 0,
  enterTouchDelay: 1000,
  innerClassName: null,
  isDark: false,
  isDisableFocusListener: false,
  isDisableHoverListener: false,
  hasTouchListener: true,
  isOpen: null,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  placement: 'top'
};
var _default = Tooltip;
exports["default"] = _default;